import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInformation = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M9 5a1 1 0 11-2 0 1 1 0 012 0zM9 7v5H7V7h2z" }), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-2 0A6 6 0 112 8a6 6 0 0112 0z"
	})]
});
export default SvgInformation;
